<template>
  <div>

    <div class="favourite-title">
      <h4>快速查詢:</h4>


      <div class="edit-button"
           @click="toggleEdit()"
      >
        <md-icon>edit</md-icon>
      </div>
    </div>

    <div class="favourite-routes">
      <FavouriteRoute
        v-for="(fav, index) in favourites"
        :key="index"
        :editable="true"
        :favouriteRoute="fav"
      />

      <div
        v-if="favourites.length === 0"
        class=""
      >未有紀錄
      </div>
    </div>

    <div class="spacer-10"></div>
    <div class="separator"></div>

  </div>
</template>

<script>
import FavouriteRoute from './FavouriteRoute'
import {mapActions, mapMutations, mapState} from 'vuex';
// import favourite from "../../store/favourite";

export default {
  name: "FavouriteHome",
  components: {
    FavouriteRoute
  },
  computed: {
    ...mapState('favourite', ['favourites'])
  },
  methods: {
    ...mapMutations('favourite', ['toggleEditMode']),
    ...mapActions('favourite', ['getFavouriteList']),
    toggleEdit() {
      console.log('toggling edit favourite');

      this.toggleEditMode('aa');
    },
  },
  mounted() {
    this.getFavouriteList();

    console.log("FAVOURITES", this.favourites);

  }
}
</script>

<style scoped>
.favourite-title {
  margin: 16px 0;
}

.favourite-title > h4 {
  display: inline-block;
  margin: 0;
  font-size: 120%;
}

.favourite-title > .edit-button {
  display: inline-block;
  float: right;
}
</style>
